enum ActionTypes {
  TRACK = "acko/track",
  NEW_CAR_TRACK = "acko/new_car",
  NEW_CAR_TRACK_SUCCESS = "acko/new_car_success",
  NEW_CAR_GTM = "acko/new_car_gtm",
  GTM = "acko/GTM"
}

export default ActionTypes;
